/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["li[_ngcontent-%COMP%]{display:inline-block}pre[_ngcontent-%COMP%]{margin-left:0;margin-right:0;height:70vh}"];
export { styles as styles };
